import { Bot, ClipboardCopy } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import CoinBadge from "../../components/CoinBadge";
import { toast } from "sonner";

let chatWindow = null;

export default function TutorIA() {
    const { user } = useAuth();

    // Nombre del colegio dinámico según el usuario autenticado
    const schoolName = user?.school || "Grit";
    const schoolKey = schoolName.toUpperCase().replace(/\s+/g, "_");

    async function newSession() {
        const prompt = `IDENTIDAD_CONFIGURADA: GRIT_ALUMNO_${schoolKey}. Hola, soy ${user?.name || "un estudiante"} del colegio ${schoolName}. Salúdame como el Profesor de IA de Grit y ayúdame con mi sesión de aprendizaje.`;

        try {
            await navigator.clipboard.writeText(prompt);
            toast.success("¡Prompt copiado! Pégalo (Ctrl+V) en el chat de Gemini.");
        } catch (err) {
            console.error("Error al copiar:", err);
        }

        const url = "https://gemini.google.com/app";
        if (chatWindow && !chatWindow.closed) {
            chatWindow.focus();
        } else {
            chatWindow = window.open(url, "GritChat", "noopener,noreferrer");
        }
    }

    return (
        <div className="h-full flex flex-col fade-in p-6 md:p-10">
            <div className="flex justify-between items-center mb-8">
                <div>
                    <h1 className="text-2xl font-semibold">Tutor IA</h1>
                    <p className="text-sm text-edu-body">Tu asistente personal para resolver dudas.</p>
                </div>
                {user && <CoinBadge amount={user.coin_balance} size="lg" />}
            </div>

            <div className="flex-1 edu-card flex flex-col items-center justify-center text-center p-10 bg-[#F8F9FB]">
                <Bot size={64} className="text-edu-navy mb-6" />
                <h2 className="text-2xl font-semibold mb-3">¡Hola! Soy tu Profesor de IA</h2>
                <div className="text-edu-body max-w-md mb-8 space-y-4">
                    <p>Al iniciar, se copiará una instrucción especial automáticamente.</p>
                    <div className="bg-white p-4 rounded-xl border border-dashed border-edu-navy/30">
                        <p className="text-xs text-edu-muted mb-2 font-semibold uppercase">Instrucción para pegar:</p>
                        <code className="text-edu-navy font-bold text-sm block break-words">
                            IDENTIDAD_CONFIGURADA: GRIT_ALUMNO_{schoolKey}
                        </code>
                    </div>
                    <p className="text-sm text-edu-muted">
                        Solo abre el chat y presiona{" "}
                        <kbd className="bg-gray-200 px-2 py-0.5 rounded text-xs">Ctrl + V</kbd>{" "}
                        para activar tu tutor personalizado.
                    </p>
                </div>

                <button
                    onClick={newSession}
                    className="edu-btn-primary px-8 py-3 flex items-center gap-2 text-lg transition-all shadow-lg hover:scale-105"
                >
                    <ClipboardCopy size={20} />
                    Copiar prompt e iniciar sesión
                </button>
            </div>
        </div>
    );
}
